import {
  OPEN_FILE_FROM_URL,
  OPEN_FILE_FROM_PRIVATE_DRIVE,
} from '../constants/openfile.constants';
import {isCNDomain} from 'Utils/utils'
// import {
//   getConfig
// } from 'Api/private_drive/private_drive.api'
//import bindCallbacks from '../callbacks';
function fragmentTemplate({ target, iconName, name, lngKey }) {
  let ACTIONS = window.UIExtension.UIConsts.FRAGMENT_ACTION;
  let art = `
        <dropdown-button icon-class="fv__icon-toolbar-${iconName}" name="${name}" accept=".pdf" @cannotBeDisabled>
                ${lngKey}
        </dropdown-button>
    `;
  let fragment = {
    // 替换控件
    action: ACTIONS.AFTER,
    // 目标控件名称， 控件将被添加这个空间里面，必须确保它是一个容器类型的控件
    target: target,
    template: art,
  };
  return fragment;
}

//const list = [OPEN_FILE_FROM_URL, OPEN_FILE_FROM_GOOGLE_DRIVE, OPEN_FILE_FROM_ONE_DRIVE, OPEN_FILE_FROM_BOX, OPEN_FILE_FROM_DROPBOX];
export default function AddModule(callback, isOnPremiseDeployMode) {
  let fragments = [
    {
      target: 'open-file-button-list',
      config: {
        callback: class MyController extends UIExtension.Controller {
          mounted(){
              //this.component.select(this.component.childAt(0));
          }
        },
        attrs: {
          '@tooltip': '',
          'tooltip-title': 'phantom_online:toolbar.buttons.openFile',
        },
      },
    }
    //fragmentTemplate({ target: OPEN_FILE_LOCAL, iconName: 'open-url', name: OPEN_FILE_FROM_URL, lngKey: 'toolbar.buttons.openFromUrl' }),
  ];
  if (!isOnPremiseDeployMode) {
    if(isCNDomain()){
      return { fragments };;
    }
  } else {
    fragments.push(
      fragmentTemplate({
        target: OPEN_FILE_FROM_URL,
        iconName: 'open-private-drive',
        name: OPEN_FILE_FROM_PRIVATE_DRIVE,
        lngKey: 'phantom_online:toolbar.buttons.openFromPrivateDrive',
      }),
      // fragmentTemplate({
      //   target: OPEN_FILE_FROM_URL,
      //   iconName: 'open-s3',
      //   name: OPEN_FILE_FROM_PRIVATE_DRIVE_S3,
      //   lngKey: 'phantom_online:toolbar.buttons.openFromPrivateDriveS3',
      // }),
      // fragmentTemplate({
      //   target: OPEN_FILE_FROM_PRIVATE_DRIVE_S3,
      //   iconName: 'open-nfs',
      //   name: OPEN_FILE_FROM_PRIVATE_DRIVE_NFS,
      //   lngKey: 'phantom_online:toolbar.buttons.openFromPrivateDriveNFS',
      // }),
    );
  }

  // let smb = [];
  // let s3 = [];
  // let nfs = [];
  // let res = await getConfig();

  // res.data &&
  //   res.data.storage.forEach((item) => {
  //     switch (item.type) {
  //       case 1:
  //         smb.push(item);
  //         break;
  //       case 2:
  //         s3.push(item);
  //         break;
  //       case 3:
  //         nfs.push(item);
  //         break;
  //       default:
  //         break;
  //     }
  //   });

  // if (smb.length !== 0) {
  //   fragments.push(
  //     fragmentTemplate({
  //       target: OPEN_FILE_FROM_DROPBOX,
  //       iconName: 'open-private-drive',
  //       name: OPEN_FILE_FROM_PRIVATE_DRIVE,
  //       lngKey: 'phantom_online:toolbar.buttons.openFromPrivateDrive',
  //     }),
  //   );
  // }

  return { fragments };
}
